<template>
  <div id="fy_card" class="parent_container">
    <h2>{{card_container.title}}</h2>
    <h4 v-for="item in card_container.h4">{{item}}</h4>
    <img class="img-responsive" :src="card_container.imgSrc">
  </div>
</template>

<script>
    import './../assets/css/fy_container_card.css'

    export default {
        name: "fy_container_hard",
        props: ['card_container']
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/fy_container_card.vue